import styled from "styled-components";
import { Card } from "antd";

export const SbCardWrapper = styled(Card)`
  border-radius: 8px;

  .ant-card-head-title {
    white-space: normal;
  }
`;